import React, { useState } from 'react';
import XLSX from 'xlsx';
import { Upload, Button, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import keywords,{keyGroupArray,keyToLabel,getLabelKey,getKeyGroup,getLabelsByGroup} from './keywords';
import { v4 as uuidv4 } from 'uuid';
import Language from './language';
const mappedData = ({lng,data,Labels={}})=>data.map((row) => {
  
  const newRow = {id:uuidv4()};
  for (const rowKey in row) {      
    if (Labels.hasOwnProperty(rowKey)) {
      const value=row[rowKey];
      const {key,options} = Labels[rowKey];
      
      newRow[key] = getLabelKey(lng,key,value,options);
      
      // console.log(getLabelKey(lng,key,value));
    }     
  }
  return newRow;
});




const readSheet =({lng,workbook,sheet,startCell,endCell,skip,filterKey,Labels})=>{ 
  const worksheet = workbook.Sheets[sheet];  
  
  const data = XLSX.utils.sheet_to_json(worksheet, {
          range: XLSX.utils.decode_range(`${startCell}:${endCell}`),
          header: 0,
        });        
  data.splice(0,skip);       
  
  
  const values = mappedData({lng,data,Labels});    
  
  const results =  values.filter(o=>typeof o[filterKey]!=="undefined" && !(typeof o[filterKey]==="string" && o[filterKey]==""));
  // console.log("sheet",sheet,data,values,results,filterKey)
  
  return results;            
};

const readIntroduction=({lng="en",workbook})=>{
  const sheet = "Introduction"
  const Labels = {
  0: {"key":'terminalName'},
  1: {"key":'invYear',options:"invYear"},    
  2: {"key":'province',"options":"region"},
  3: {"key":'portAuthority',"options":"port"},  
  4: {"key":'scenario',"options":"scenario"},
  
}
  const worksheet = workbook.Sheets[sheet];  
  const startCell = 'C19'; 
  const endCell = 'D24';   
  const _data = XLSX.utils.sheet_to_json(worksheet, {
          range: XLSX.utils.decode_range(`${startCell}:${endCell}`),
          header: 0,
        });   
  
  
  const data = [_data.reduce((acc,o,i)=>({...acc,[i]:o["__EMPTY_1"]}),{})]  
  
  const values = mappedData({lng,data,Labels});  
  
  return values[0];
};

const readTerminal=({lng,...props})=>readSheet({lng,...props,sheet:"Terminal",startCell:"D15",endCell:"K23",skip:2,filterKey:"annualThroughput",Labels:{
  "__EMPTY": {"key":'commodityType',options:"commodityType"},
  "__EMPTY_1": {"key":'annualThroughput'},    
  "__EMPTY_4": {"key":'units',options:"unitsTerminal"},
  "__EMPTY_7": {"key":'notes'},
}});

const readAdmin=({lng,...props})=>readSheet({lng,...props,sheet:"Admin",startCell:"D16",endCell:"H29",skip:3,filterKey:"totalAnnualConsumption",Labels:{
   "__EMPTY": {"key":'equipmentType',"options":"equipmentTypeAdmin"},  
   "__EMPTY_2": {"key":'fuelType',"options":"fuelType"},     
   "__EMPTY_3": {"key":'totalAnnualConsumption'},
   "__EMPTY_4": {"key":'units',"options":"units"},
   "__EMPTY_5": {"key":'notes'},
}});


const readCHEp1=({lng,...props})=>readSheet({lng,...props,sheet:"CHE-EMF",startCell:"D15",endCell:"G25",skip:2,filterKey:"annualFuel",Labels:{
  "__EMPTY": {"key":'fuelType',"options":"fuelType"},
  "__EMPTY_1":{"key":"annualFuel"},
  "__EMPTY_2": {"key":'units',"options":"units"},
  "__EMPTY_3":{"key":"notes"},   
}});

const readCHEp2=({lng,...props})=>readSheet({lng,...props,sheet:"CHE-EMF",startCell:"D27",endCell:"M129",skip:3,filterKey:"annualHours",Labels:{
  "__EMPTY":{"key":"equipmentType",options:"equipmentTypeCHE"},
  "__EMPTY_1":{"key":"modelYear"},
  "__EMPTY_2":{"key":"similarUnits"},
  "__EMPTY_3":{"key":"isRetrofit"},
  "__EMPTY_4":{"key":"retrofitType",options:"retrofit"},
  "__EMPTY_5":{"key":"fuelId"},  
  "__EMPTY_6":{"key":"enginePower"},
  "__EMPTY_7":{"key":"powerUnits",options:"powerUnits"},    
  "__EMPTY_8":{"key":"annualHours"},            
  "__EMPTY_9":{"key":"notes"},
}});


const readRoadp1=({lng,...props})=>readSheet({lng,...props,sheet:"Onroad-Transport routier",startCell:"D15",endCell:"O28",skip:3,filterKey:"annualGateCounts",Labels:{
  "__EMPTY":{"key":"vehicleType",options:"fleet"},
  "__EMPTY_1":{"key":"fuelType",options:"fuelType"},
  "__EMPTY_2":{"key":"annualGateCounts"},  
  "__EMPTY_3":{"key":"cTime"},
  "__EMPTY_4":{"key":"cDriving"},
  "__EMPTY_5":{"key":"cIdling"},  
  "__EMPTY_6":{"key":"ageProfile",options:"ageProfile"},
  "__EMPTY_7":{"key":"dEntry"},
  "__EMPTY_8":{"key":"dExit"},
  "__EMPTY_9":{"key":"dIdling"},
  "__EMPTY_10":{"key":"dSpeed"},                       
  "__EMPTY_11": {"key":'notes'},          
}});
const readRoadp2=({lng,...props})=>readSheet({lng,...props,sheet:"Onroad-Transport routier",startCell:"D30",endCell:"F40",skip:2,filterKey:"annualFuel",Labels:{
   "__EMPTY": {"key":'fuelType',options:"fuelType"},
   "__EMPTY_1":{"key":"annualFuel"},
   "__EMPTY_2": {"key":'units',options:"units"},   
}});

const readRoadp3=({lng,...props})=>readSheet({lng,...props,sheet:"Onroad-Transport routier",startCell:"D42",endCell:"H74",skip:2,filterKey:"numberVechicles",Labels:{
  "__EMPTY":{"key":"vehicleType",options:"fleet"},
  "__EMPTY_1":{"key":"modelYear"},
  "__EMPTY_2":{"key":"numberVechicles"},    
  "__EMPTY_3":{"key":"intensity",options:"intensity"},             
  "__EMPTY_4":{"key":"fuelId"},      
}});

const readRoadp4=({lng,...props})=>readSheet({lng,...props,sheet:"Onroad-Transport routier",startCell:"D76",endCell:"K109",skip:2,filterKey:"number",Labels:{
   "__EMPTY":{"key":"number"},
  "__EMPTY_1":{"key":"percentage"}, 
  "__EMPTY_2":{"key":"numberA"},
  "__EMPTY_3":{"key":"percentageA"}, 
  "__EMPTY_4":{"key":"numberB"}, 
  "__EMPTY_5":{"key":"percentageB"}, 
  "__EMPTY_6":{"key":"numberC"}, 
  "__EMPTY_7":{"key":"percentageC"}, 
}});

const readRailp1=({lng,...props})=>readSheet({lng,...props,sheet:"Rail-Transport ferroviaire",startCell:"D15",endCell:"K25",skip:2,filterKey:"annualTrainVisits",Labels:{
  "__EMPTY":{"key":"serviceProvider",options:"serviceProvider"},
  "__EMPTY_1":{"key":"annualTrainVisits"},
  "__EMPTY_2":{"key":"averageInbound"},
  "__EMPTY_3":{"key":"averageOutbound"},
  "__EMPTY_4":{"key":"distanceTerminalPort"},
  "__EMPTY_5":{"key":"timeSpent"},
  "__EMPTY_6":{"key":"workDone",options:"workDone"},
  "__EMPTY_7":{"key":"notes"},  
  }});

const readRailp2=({lng,...props})=>readSheet({lng,...props,sheet:"Rail-Transport ferroviaire",startCell:"D28",endCell:"J41",skip:3,filterKey:"annualFuel",Labels:{
    "__EMPTY":{"key":"ownership",options:"trainOwnership"},
    "__EMPTY_1":{"key":"model",options:"modelType"},
    "__EMPTY_2":{"key":"engineYear",options:"trainAgeProfile"},
    "__EMPTY_3": {"key":'fuelTypeTrain',options:"fuelTypeTrain"},
    "__EMPTY_4":{"key":"annualFuel"},
    "__EMPTY_5": {"key":'units',options:"units"},   
    "__EMPTY_6":{"key":"numberUnits"},          
    "__EMPTY_7":{"key":"notes"},  
  }});

const readMarinep1=()=>([])

const readMarinep2=({lng,...props})=>readSheet({lng,...props,sheet:"Marine-Transport maritime",startCell:"D17",endCell:"E120",skip:2,filterKey:"shipId",Labels:{
  // "__EMPTY":{"key":"imo"}, 
  "__EMPTY_1":{"key":"shipId"}   
  }});
// const readMarinep2=()=>null;

const getFuelId = (array,str)=>{
  
  const itemNumber=parseInt(str.split("-")[0]);
  if(!itemNumber)return "";
  return array[itemNumber-1]?.id;  
}

const getProfileId = (array,str)=>{  
  
  if(str=="UserA")return array[1].id;
  if(str=="UserB")return array[2].id;
  if(str=="UserC")return array[3].id;
  
  return array[0].id
  
  
}
const getPercentage=(v)=>{
  if(!v)return 0
  if(v==" ")return 0
  
  return v*100.0
}
const ExcelHandler = ({onFinish}) => {
  
  // const [fileName, setFileName] = useState('');
  let lng="en"
  // Function to handle file upload
  const handleFileUpload = (info) => {    
    if (info.file.status === 'done') {
      // setFileName(info.file.name);
      if(info.file.type==="application/json"){
        const reader = new FileReader();
        
        reader.onload = function(e) {
          const fileContent = e.target.result; // The file content
          try {
            const input = JSON.parse(fileContent); // Parse the JSON data
              const newData ={
                "id":uuidv4(),
                "name":info.file.name,
                "radioKey":"input",
                "isSave":true,
                "notes":"",
                input
              }
              onFinish&&onFinish(newData);
            } catch (error) {
              console.error('Error parsing JSON:', error);
            }
          };        
          
          reader.readAsText(info.file.originFileObj);        
      } else {

        const reader = new FileReader();
        reader.onload = (e) => {
          try{
          const binaryString = e.target.result;
          const workbook = XLSX.read(binaryString, { type: 'binary' });
          const _lng = workbook.Sheets["Language-Langue"]["F21"].v;
          lng = _lng=="English"?"en":"fr";
          
          const che_fuel = readCHEp1({lng,workbook})
          const _che_equipment = readCHEp2({lng,workbook})        
          const che_equipment =_che_equipment.map(row=>({...row,"fuelId":getFuelId(che_fuel,row?.fuelId),isRetrofit:row?.isRetrofit??false,retrofitType:row?.retrofitType??"None"}))
          
          const road_fuel = readRoadp2({lng,workbook});
          const _road_equipment = readRoadp3({lng,workbook});    
          const road_equipment = _road_equipment.map(row=>({...row,"fuelId":getFuelId(road_fuel,row?.fuelId)}));
          
          
          
          
          const AverageProfile = {
            id:uuidv4(),
            name:lng=="en"?"Average":"Moyen / inconnu",
             data:readRoadp4({lng,workbook}).map((o,i)=>({id:i,age:i,number:o["number"]||0,percentage:getPercentage(o["percentage"])})),
          };
          
          const AProfile = {
            id:uuidv4(),
            name:lng=="en"?"User-defined A":"Défini par l'usager A",
            data:readRoadp4({lng,workbook}).map((o,i)=>({id:i,age:i,number:o["numberA"]||0,percentage:getPercentage(o["percentageA"])})),
          };
          const BProfile = {
            id:uuidv4(),
            name:lng=="en"?"User-defined B":"Défini par l'usager B",
            data:readRoadp4({lng,workbook}).map((o,i)=>({id:i,age:i,number:o["numberB"]||0,percentage:getPercentage(o["percentageB"])})),
          };
          const CProfile = {
            id:uuidv4(),
            name:lng=="en"?"User-defined C":"Défini par l'usager C",
            data:readRoadp4({lng,workbook}).map((o,i)=>({id:i,age:i,number:o["numberC"]||0,percentage:getPercentage(o["percentageC"])})),
          };          
          const custom = [AverageProfile,AProfile,BProfile,CProfile];
          const _highwayVehicles=readRoadp1({lng,workbook});
          const highwayVehicles=_highwayVehicles.map(row=>({...row,"ageProfile":getProfileId(custom,row.ageProfile)}));
          const introduction = readIntroduction({lng,workbook})
          
          const newData ={
            "id":uuidv4(),
            "name":info.file.name,
            "notes":introduction?.terminalName,
            "radioKey":"input",
            "isSave":true,
            "input":{
              "introduction":introduction,
              "terminal":readTerminal({lng,workbook}),
              "admin":readAdmin({lng,workbook}),
              "marine":{
                zone:readMarinep1({lng,workbook}),
                vessel:readMarinep2({lng,workbook}),
              },
              "che":{
                fuel:che_fuel,
                equipment:che_equipment,
              },
              "road":{
                fuel:road_fuel,
                vehicles:road_equipment,
                highwayVehicles:highwayVehicles,
                custom
              },
              rail:{
                national:readRailp1({lng,workbook}),
                facility:readRailp2({lng,workbook}),
              }            
            }
            
          
          }
          onFinish&&onFinish(newData);
          } catch (e){
           message.error('File upload failed.');
          }
          
          
        };
  
        reader.readAsBinaryString(info.file.originFileObj);
      }  
    } else if (info.file.status === 'error') {
      message.error('File upload failed.');
    }
  };  

  return (
    <div>    
      <Upload.Dragger
        name="file"
        accept={[".xlsx",".json"]}
        customRequest={({ onSuccess, onError, file }) => {
          setTimeout(() => {
            onSuccess({}, file);
          }, 1000);
        }}
        onChange={(info) => handleFileUpload(info)}
      >
        <p className="ant-upload-drag-icon">
          <UploadOutlined />
        </p>
        <p className="ant-upload-text"><Language id="uploadmessage"/></p>
        <p className="ant-upload-hint">                    </p>
      </Upload.Dragger>
      
     
     
    </div>
  );
};

export default ExcelHandler;